var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconShaping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 222,
    viewBox: "0 0 61 222",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1C12.7709 2.11567 36.3128 15.8942 36.3128 62.0831C36.3128 108.272 55.4376 113.404 60 110.197M1 221C12.7709 219.884 36.3128 206.106 36.3128 159.917C36.3128 113.728 55.4376 108.596 60 111.803",
    stroke: "white",
    strokeDasharray: "2 2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShaping);
export default __webpack_public_path__ + "static/media/icon_shaping.f049f15b8f5f2dfba576e4b089767d19.svg";
export { ForwardRef as ReactComponent };